import React, { useEffect, useState } from "react";
import {
  CombineInputGroup,
  InputGroup,
  Label,
  RupeeIcon,
} from "../../../Components/Styles/InputStyles";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { useFormik } from "formik";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendar } from "react-icons/fa";
import { BoxHead, Underline } from "../../Styles/PageStyles";
import Config from "../../../Config";
import { useSelector } from "react-redux";
import { MdEdit } from "react-icons/md";
import SelectOptionModal from "../../SelectOptionModal";

export default function RentDetails({
  tenantData,
  setSelectedData,
  selectedData,
  editRentDetailMutate,
  isRentDetailLoading,
  e
}
) {
  const staffList = useSelector((state) => state.StaffListReducer.staffList);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [calendarMoveOutOpen, setCalendarMoveOutOpen] = useState(false);
  const [isBookedByOpen, setIsBookedByOpen] = useState(false);
  // const staffListOptions = staffList
  //   ?.filter(type => type?.name && type?.id)
  //   .map(type => ({
  //     label: type.name,
  //     value: type.id,
  //   })) || [];
  // const getBookedByLabel = (value) => {
  //   if (!value) return "Select Booked by...";
  //   const staff = staffListOptions.find(option => option.value === value);
  //   return staff ? staff.label : "Select Booked by...";
  // };
  const staffListOptions = staffList
    ?.filter(type => type?.name && type?.id)
    .map(type => ({
      label: type.name,
      value: type.id,
    })) || [];

  // Updated function to get the label for booked by
  const getBookedByLabel = (bookedByValue, bookedByName) => {
    // If bookedBy is 0 (owner), show the bookedByName
    if (bookedByValue === 0) {
      return bookedByName || "Owner";
    }

    // If bookedBy has a value, try to find it in staff list
    if (bookedByValue) {
      const staff = staffListOptions.find(option => option.value === bookedByValue);
      return staff ? staff.label : "Select Booked by...";
    }

    // Fallback
    return "Select Booked by...";
  };

  const rentFormik = useFormik({
    initialValues: {
      rentalType: tenantData?.occupancy?.rentalType,
      rent: tenantData?.occupancy?.rent,
      security: tenantData?.occupancy?.security,
      moveInDate: moment(tenantData?.occupancy?.moveInDate).format("YYYY-MM-DD"),
      occupiedMoveOutDate: tenantData?.occupancy?.moveOutDate
        ? moment(tenantData.occupancy.moveOutDate).format("YYYY-MM-DD")
        : "",
      totalDues: tenantData?.totalDues,
      rentalCycle: tenantData?.occupancy?.rentalCycle,
      agreementPeriod: tenantData?.occupancy?.agreementPeriod?.toString() || "",
      lockInPeriod: tenantData?.occupancy?.lockInPeriod?.toString() || "",
      noticePeriod: tenantData?.occupancy?.noticePeriod?.toString() || "",
      moveOutDate: tenantData?.occupancy?.stayType === 2 ? moment(tenantData?.occupancy?.moveOutDate).format("YYYY-MM-DD") : moment(tenantData?.occupancy?.agreementStartDate)
        .add(tenantData?.occupancy?.agreementPeriod, 'months')
        .subtract(1, 'day')
        .format('YYYY-MM-DD'),
      createdAt: moment(tenantData?.occupancy?.createdAt).format("YYYY-MM-DD"),
      isOnlinePaymentEnabled: tenantData?.occupancy?.isOnlinePaymentEnabled,
      rentalBond: tenantData?.occupancy?.rentalBond,
      notes: tenantData?.occupancy?.notes,
      bookedBy: tenantData?.occupancy?.bookedBy,
      bookedByName: tenantData?.occupancy?.bookedByName,
      agreementStartDate: tenantData?.occupancy?.agreementStartDate,
    },
    validationSchema: Yup.object({
      rent: Yup.number(),
      moveInDate: Yup.date(),
      // occupiedMoveOutDate: Yup.date(),
      rentalCycle: Yup.string(),
      agreementPeriod: Yup.number(),
      lockInPeriod: Yup.number(),
      noticePeriod: Yup.number(),
    }),
    onSubmit: (values) => {
      if (!values.rentalType && Number(values.rentalType) !== 0) {
        toast.error("Rental Type is required");
        return;
      }

      if (!values.rent) {
        toast.error("Rent is required");
        return;
      }
      if (!values.rentalCycle) {
        toast.error("Rental Cycle is required");
        return;
      }
      if (!values.agreementPeriod) {
        toast.error("Agreement Period is required");
        return;
      }
      if (!values.lockInPeriod) {
        toast.error("Lock-in Period is required ");
        return;
      }
      if (
        values.noticePeriod === null ||
        values.noticePeriod === undefined ||
        values.noticePeriod === ''
      ) {
        toast.error("Notice Period is required");
        return;
      }
      if (!values.moveInDate) {
        toast.error("Move In Date is required");
        return;
      }

      editRentDetailMutate(values);
    },
    enableReinitialize: true,
  })
  // const handleBookedBySelect = (selectedValue) => {
  //   rentFormik.setFieldValue("bookedBy", selectedValue);
  //   setIsBookedByOpen(false);
  // };
  const handleBookedBySelect = (selectedValue) => {
    // When a staff member is selected from the modal
    const selectedStaff = staffListOptions.find(option => option.value === selectedValue);
    rentFormik.setFieldValue("bookedBy", selectedValue);
    rentFormik.setFieldValue("bookedByName", selectedStaff ? selectedStaff.label : "");
    setIsBookedByOpen(false);
  };
  const rentalCycle = [
    { label: "1st to 1st", value: "01" },
    { label: "15th to 15th", value: "15" },
    { label: "Move-In Date", value: "00" },
  ];
  const onlinePaymentOptions = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];
  const rentalBondOptions = [
    { label: "Yes", value: 2 },
    { label: "No", value: 1 },
    { label: "No", value: 0 },
  ];
  const rentalType = [
    { label: "Monthly", value: 1 },
    { label: "Quarterly", value: 3 },
    { label: "Half-Yearly", value: 6 },
    { label: "Annual", value: 12 },
    { label: "Short Stay", value: 0 },
  ];

  const getInputClass = (isDisabled) => {
    return isDisabled
      ? "bg-gray-100 cursor-not-allowed" : "pl-2 relative rounded-md w-full flex items-center border border-gray-400 h-12";
  };
  // const currentBookedByLabel = getBookedByLabel(rentFormik.values.bookedBy);
  const currentBookedByLabel = getBookedByLabel(
    rentFormik.values.bookedBy,
    rentFormik.values.bookedByName
  );
  return (
    <>
      <SelectOptionModal
        isOpen={isBookedByOpen}
        onClose={() => setIsBookedByOpen(false)}
        title="Select Booked By"
        options={staffListOptions}
        selectedValue={rentFormik.values.bookedBy}
        onSelect={handleBookedBySelect}
        searchPlaceholder="Search staff members..."
        width="1/3"
      />
      <div>
        {/* <Title>Rent Details</Title> */}
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Rent Details
            <Underline />
          </BoxTitle>
          <div className="text-xs text-gray-500">
            Created on&nbsp;
            <span className="font-medium text-gray-700">
              {moment(tenantData?.createdAt).format("MMM DD, YYYY")}
            </span>
          </div>
        </BoxHead>
        <form
          onSubmit={rentFormik.handleSubmit}
          className="grid grid-cols-1 md:gap-4"
        >
          <CombineInputGroup>
            <InputGroup>

              <Label>Rental Type *</Label>
              <Select
                id="rentalType"
                name="rentalType"
                className="w-full pl-2 bg-gray-100"
                value={rentFormik.values.rentalType}
                onChange={rentFormik.handleChange}
                onBlur={rentFormik.handleBlur}
                sx={{
                  height: "48px",
                  borderRadius: "6px",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#a3a3b9",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#d1d5db",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#0284C7",
                  },
                }}
                disabled
              >
                {rentalType.map((mode) => (
                  <MenuItem key={mode.value} value={mode.value}>
                    {mode.label}
                  </MenuItem>
                ))}
              </Select>
            </InputGroup>

            <InputGroup>
              <Label htmlFor="rent">Rent (₹)</Label>
              <FieldWrapperX>
                <RupeeIcon />
                <Input
                  type="text"
                  id="rent"
                  name="rent"
                  value={rentFormik.values.rent}
                  disabled={rentFormik.values.rentalType === 0}
                  //className={getInputClass(rentFormik.values.rentalType === 0)}
                  // className="pl-6 h-12 border-none"
                  className={getInputClass(false) + "border-none pl-6 h-12"}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      rentFormik.setFieldValue("rent", value);
                    }
                  }}
                  onBlur={rentFormik.handleBlur}
                />
              </FieldWrapperX>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="security">Security (₹)</Label>
              <FieldWrapperX>
                <RupeeIcon />
                <Input
                  id="security"
                  name="security"
                  disabled
                  className={getInputClass(false) + "border-none pl-6 h-12"}
                  value={rentFormik.values.security}
                  onChange={rentFormik.handleChange}
                />
              </FieldWrapperX>
            </InputGroup>
          </CombineInputGroup>


          <CombineInputGroup>

            <InputGroup>
              <Label htmlFor="moveInDate">{tenantData?.occupancy?.stayType === 2 ? "Check-In Date" : "Move-In Date"}</Label>
              <FieldWrappers
                className={rentFormik.values.rentalType === 0 ? "relative bg-gray-100 cursor-not-allowed h-12" : "relative cursor-pointer items-center h-12 border border-gray-400"}>
                <DatePicker
                  selected={rentFormik.values.moveInDate ? moment(rentFormik.values.moveInDate, "YYYY-MM-DD").toDate() : null}
                  onChange={(date) => {
                    rentFormik.setFieldValue("moveInDate", moment(date).format("YYYY-MM-DD"));
                    setCalendarOpen(false);
                  }}
                  onBlur={rentFormik.handleBlur}
                  onClickOutside={() => setCalendarOpen(false)}
                  onSelect={() => setCalendarOpen(false)}
                  open={calendarOpen}
                  onInputClick={() => setCalendarOpen(true)}
                  dateFormat="yyyy-MM-dd"
                  disabled={rentFormik.values.rentalType === 0}
                  className="cursor-pointer items-center "
                  placeholderText="Select date"
                  showIcon
                  icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                  showPopperArrow={false}
                  onFocus={(e) => e.target.blur()}
                  wrapperClassName="w-full"
                  portalId="root-portal"
                  popperClassName="react-datepicker-popper" />

                {/* <CalendarIcon onClick={() => setCalendarOpen((prev) => !prev)} /> */}
              </FieldWrappers>
            </InputGroup>
            {tenantData?.occupancy?.stayType !== 2 && tenantData?.occupancy?.status === Config.OCCUPANCY_STATUS.RESERVED &&
              <InputGroup>
                <Label htmlFor="occupiedMoveOutDate">Move-Out Date</Label>
                <FieldWrappers
                  className={rentFormik.values.rentalType === 0 ? "relative bg-gray-100 cursor-not-allowed h-12" : "relative cursor-pointer items-center h-12 border border-gray-400"}>
                  <DatePicker
                    //selected={rentFormik.values.occupiedMoveOutDate}
                    selected={rentFormik.values.occupiedMoveOutDate ? moment(rentFormik.values.occupiedMoveOutDate, "YYYY-MM-DD").toDate() : null}
                    onChange={(date) => {
                      rentFormik.setFieldValue("occupiedMoveOutDate", moment(date).format("YYYY-MM-DD"));
                      setCalendarMoveOutOpen(false);
                    }}
                    onBlur={rentFormik.handleBlur}
                    onClickOutside={() => setCalendarMoveOutOpen(false)}
                    onSelect={() => setCalendarMoveOutOpen(false)}
                    open={calendarMoveOutOpen}
                    onInputClick={() => setCalendarMoveOutOpen(true)}
                    dateFormat="yyyy-MM-dd"
                    disabled={rentFormik.values.rentalType === 0}
                    className="cursor-pointer items-center "
                    placeholderText="Select date"
                    showIcon
                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                    showPopperArrow={false}
                    onFocus={(e) => e.target.blur()}
                    wrapperClassName="w-full"
                    portalId="root-portal"
                    popperClassName="react-datepicker-popper"
                    minDate={
                      rentFormik.values.moveInDate
                        ? moment(rentFormik.values.moveInDate).toDate()
                        : null
                    } />
                </FieldWrappers>
              </InputGroup>}
            {tenantData?.occupancy?.stayType !== 2 &&
              <InputGroup>
                <Label htmlFor="agreementStartDate">Agreement Start</Label>
                <FieldWrappers
                  className={'relative cursor-pointer h-12'}>
                  <DatePicker
                    selected={rentFormik.values.agreementStartDate}
                    onChange={(date) => {
                      rentFormik.setFieldValue("agreementStartDate", moment(date).format("YYYY-MM-DD"));
                      setCalendarOpen(false);
                    }}
                    onBlur={rentFormik.handleBlur}
                    dateFormat="yyyy-MM-dd"
                    disabled
                    className="items-center"
                    showIcon
                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                    showPopperArrow={false}
                    onFocus={(e) => e.target.blur()}
                    wrapperClassName="w-full"
                    portalId="root-portal"
                    popperClassName="react-datepicker-popper" />
                </FieldWrappers>
              </InputGroup>
            }
            <InputGroup>
              <Label htmlFor="moveOutDate">{tenantData?.occupancy?.stayType === 2 ? "Check-Out Date" : "Agreement End"}</Label>
              <FieldWrappers className={'relative bg-gray-100 cursor-default h-12'}>
                <DatePicker
                  // selected={rentFormik.values.moveOutDate ? new Date(rentFormik.values.moveOutDate) : null}
                  selected={rentFormik.values.moveOutDate ? moment(rentFormik.values.moveOutDate, "YYYY-MM-DD").toDate() : null}
                  onChange={(date) => {
                    rentFormik.setFieldValue("moveOutDate", moment(date).format("YYYY-MM-DD"));
                  }}
                  onBlur={rentFormik.handleBlur}
                  dateFormat="yyyy-MM-dd"
                  className="cursor-pointer items-center"
                  disabled
                  showIcon
                  icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                  showPopperArrow={false}
                  wrapperClassName="w-full"
                  portalId="root-portal"
                  popperClassName="react-datepicker-popper" />
              </FieldWrappers>
            </InputGroup>
          </CombineInputGroup>
          {tenantData?.occupancy?.stayType !== 2 &&
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="rentalCycle">Rental Cycle (Day of Month) *</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    id="rentalCycle"
                    name="rentalCycle"
                    //className=" bg-gray-100"
                    className={getInputClass(false)}
                    value={rentFormik.values.rentalCycle}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        rentFormik.setFieldValue("rentalCycle", value);
                      }
                    }}
                    onBlur={rentFormik.handleBlur}
                    disabled />
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label htmlFor="agreementPeriod">Agreement Period (Months)</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    id="agreementPeriod"
                    name="agreementPeriod"
                    value={rentFormik.values.agreementPeriod}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        rentFormik.setFieldValue("agreementPeriod", value);
                      }
                    }}
                    className={getInputClass(false)}
                    onBlur={rentFormik.handleBlur} />
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="lockInPeriod">Lock-in Period (Months)</Label>
                <FieldWrapper>
                  <Select
                    id="lockInPeriod"
                    name="lockInPeriod"
                    className="w-full pl-2"
                    value={rentFormik.values.lockInPeriod}
                    onChange={rentFormik.handleChange}
                    onBlur={rentFormik.handleBlur}
                    sx={{
                      height: "48px",
                      borderRadius: "6px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#a3a3b9",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#0284C7",
                      },
                    }}
                  >
                    {[...Array(12).keys()].map((num) => {

                      const value = (num + 1) * 1;
                      return (
                        <MenuItem key={value} value={value}>
                          {value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FieldWrapper>
              </InputGroup>

            </CombineInputGroup>
          }
          <CombineInputGroup>
            {tenantData?.occupancy?.stayType !== 2 &&
              <InputGroup>
                <Label htmlFor="noticePeriod">Notice Period (Months)</Label>
                <FieldWrapper>
                  <Select
                    id="noticePeriod"
                    name="noticePeriod"
                    className="w-full pl-2"
                    value={rentFormik.values.noticePeriod}
                    onChange={rentFormik.handleChange}
                    onBlur={rentFormik.handleBlur}
                    sx={{
                      height: "48px",
                      borderRadius: "6px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#a3a3b9",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d1d5db",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#0284C7",
                      },
                    }}
                  >
                    {/* {[...Array(24).keys()].map((num) => {
                      const value = (num + 1) * 0.5;
                      return (
                        <MenuItem key={value} value={value}>
                          {value}
                        </MenuItem>
                      );
                    })} */}
                    {[...Array(25).keys()].map((num) => {
                      const value = num * 0.5;

                      return (
                        <MenuItem key={value} value={value}>
                          {value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FieldWrapper>
              </InputGroup>
            }
            {/* <InputGroup>
              <Label htmlFor="createdOn">Created On</Label>

              <FieldWrappers
                className={'relative bg-gray-100 cursor-default h-12'}>
                <DatePicker
                  selected={rentFormik.values.createdAt ? new Date(rentFormik.values.createdAt) : null}
                  onChange={(date) => {
                    rentFormik.setFieldValue("createdOn", moment(date).format("YYYY-MM-DD"));

                  }}
                  onBlur={rentFormik.handleBlur}
                  dateFormat="yyyy-MM-dd"
                  disabled
                  className="items-center"
                  showIcon
                  icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                  showPopperArrow={false}
                  onFocus={(e) => e.target.blur()}
                  wrapperClassName="w-full"
                  portalId="root-portal"
                  popperClassName="react-datepicker-popper" />
              </FieldWrappers>
            </InputGroup> */}
            <InputGroup>
              <Label htmlFor="isOnlinePaymentEnabled">Online Payment Enabled</Label>
              <FieldWrapper>
                <Select
                  id="isOnlinePaymentEnabled"
                  name="isOnlinePaymentEnabled"
                  className="w-full pl-2"
                  value={rentFormik.values.isOnlinePaymentEnabled}
                  onChange={rentFormik.handleChange}
                  onBlur={rentFormik.handleBlur}
                  sx={{
                    height: "48px",
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#a3a3b9",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#d1d5db",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#0284C7",
                    },
                  }}
                >
                  {onlinePaymentOptions.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FieldWrapper>
            </InputGroup>
            {/* {tenantData?.occupancy?.rentalBond && */}
            {/* <InputGroup>
              <Label htmlFor="bookedBy">Booked By</Label>
              <FieldWrapper className="bg-gray-100">
                <Input
                  id="bookedBy"
                  name="bookedBy"
                  disabled
                  className={getInputClass(false)}
                  value={rentFormik.values.bookedBy}
                  onChange={rentFormik.handleChange}
                />
              </FieldWrapper>
            </InputGroup> */}
            <InputGroup>
              <Label htmlFor="bookedBy">Booked By</Label>
              {/* <FieldWrappers
                onClick={() => {
                  // Only open modal if not owner (bookedBy !== 0)
                  if (rentFormik.values.bookedBy !== 0) {
                    setIsBookedByOpen(true);
                  } else {
                    toast.info("This is booked by the owner");
                  }
                }}
                className="rounded-md w-full flex items-center border border-gray-300 h-11 cursor-pointer hover:border-gray-400 transition-colors"
              > */}
              <FieldWrappers
                onClick={() => {
                  if (rentFormik.values.bookedBy !== 0) {
                    setIsBookedByOpen(true);
                  }
                }}
                className={`
    rounded-md w-full flex items-center border h-12 transition-colors
    ${rentFormik.values.bookedBy === 0
                    ? "border-gray-200 bg-gray-100 cursor-not-allowed pointer-events-none"
                    : "border-gray-300 cursor-pointer hover:border-gray-400"
                  }
  `}
              >
                <input
                  id="bookedBy"
                  name="bookedBy"
                  type="text"
                  readOnly
                  value={currentBookedByLabel}
                  className="w-full border-none outline-none bg-transparent cursor-pointer"
                  placeholder="Select Booked by..."
                />
                {rentFormik.values.bookedBy !== 0 && (
                  <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                )}
              </FieldWrappers>
            </InputGroup>

            {/* <InputGroup>
              <Label htmlFor="rentalBond">Rental Bond Enabled</Label>
              <FieldWrapper>
                <Select
                  id="rentalBond"
                  name="rentalBond"
                  className="w-full pl-2 bg-gray-100"
                  value={rentFormik.values.rentalBond}
                  onChange={rentFormik.handleChange}
                  onBlur={rentFormik.handleBlur}
                  style={{ height: "48px" }}
                  disabled
                >
                  {rentalBondOptions.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FieldWrapper>
            </InputGroup> */}
            {/* } */}
          </CombineInputGroup>
          {rentFormik.values.notes &&
            <InputGroup>
              <Label htmlFor="notes">Notes (Visible Only to Owner)</Label>
              <FieldWrapper>
                <Textarea
                  disabled
                  value={rentFormik.values.notes}
                  onChange={rentFormik.handleChange}
                  onBlur={rentFormik.handleBlur}
                  className="bg-gray-100"
                  id="notes"
                  name="notes"
                  rows={4}
                  placeholder="Write remarks or reminders for future reference"
                />
              </FieldWrapper>
            </InputGroup>}
          <BtnWrapper>
            <SubmitBtn
              type="submit"
              disabled={e ? true : isRentDetailLoading}
            >
              {isRentDetailLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </div>

    </>
  );
}

const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
const FieldWrappers = tw.div`pl-2 rounded-md  w-full flex items-center border border-gray-300 h-11`;
const FieldWrapperX = tw.div`relative rounded-md w-full flex items-center border border-gray-200 h-12`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;
const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-30 resize-y  break-words overflow-hidden`;
const SubmitBtn = tw.button`
text-sm  w-24  md:w-20 h-7 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;
const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;
